import * as React from "react";

const Waves = () => {
	return (
		<>
			<svg
				className={"Waves"}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 1440 320"
			>
				<path
					fillOpacity="1"
					d="M0,160L80,133.3C160,107,320,53,480,64C640,75,800,149,960,154.7C1120,160,1280,96,1360,64L1440,32L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
				></path>
			</svg>
		</>
	);
};

export default Waves;
